import classNames from 'classnames';
import { FormEvent, useEffect, useState } from 'react';
import Loader from 'src/components/loader';
import { useGetReport, useGetReportForm } from 'src/queries/userstory';
import styles from './styles.module.scss'
import { Form } from './form';
import { ReportTable } from './reportTable';

export default function ReportPage() {
  const { data, isLoading, isFetching } = useGetReportForm();
  const { mutate: getReport, data: reportData } = useGetReport();
  const [reportList, setReportList] = useState<null | string>(null)
  useEffect(() => {
    if (data) {
      const formItem = data.data.forms[0]
      setReportList(JSON.stringify({ parameters: formItem.parameters, endpoint: formItem.endpoint }))
    }
  }, [data])
  const submitReportForm = (e: FormEvent<EventTarget>) => {
    e.preventDefault();
    if (!reportList) return;
    const p2e = (s: string) => s.replace(/[۰-۹]/g, (d: string) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(d)))
    const formValues: { [key: string]: string } = {}
    for (let i = 0; i < (e.target as HTMLFormElement).length; i++) {
      const element = (e.target as HTMLFormElement)[i];
      const value = (element as HTMLInputElement).value
      const name = (element as HTMLInputElement).name
      if (formValues[name]) {
        formValues[name] += ',' + p2e(value)
      } else {
        formValues[name] = p2e(value)
      }
    }
    console.log(formValues)
    const queryParams = Object.keys(formValues)
      .filter(key => key.length > 0 && formValues[key].length > 0)
      .map(key => `${key}=${formValues[key]}`)
      .join('&');
    console.log(queryParams)
    // getReport({ url: JSON.parse(reportList).endpoint.split('report/')[1], param: queryParams })
  }
  return (
    <div className="pt-5">
      <div>
        <label className='text-xs mb-2'>فرم مورد نظر خود را انتخاب نمایید :</label>
        <select className='border rounded-md mx-4 py-1 pl-10 text-right' onChange={(e) => {
          // console.log(e.target.value);
          setReportList(e.target.value)
        }}>
          {data && data.data.forms.map((item: any, index: any) => {
            return <option key={'form_list_' + index} value={JSON.stringify({ parameters: item.parameters, endpoint: item.endpoint })}>{item.name}</option>
          })}
        </select>
        <form onSubmit={submitReportForm}>
          <div className={classNames('flex justify-between flex-wrap', styles['form-wrapper'])}>
            {(!isLoading && !isFetching) && <Form reportList={reportList} />}
          </div>
          <button className="py-2 px-5 bg-lime-500 rounded-lg block" type="submit">دریافت گزارش</button>
        </form>
        {reportData &&
          <div>
            {reportData.data.report.length > 0 && reportData.data.report.map((item: any, index: number) => {
              return <ReportTable item={item} key={'report_table_' + index} />
            })}
          </div>
        }
      </div>

      {(isLoading || isFetching) && <Loader />}
    </div >
  );
}
